module.exports = __webpack_public_path__ + "static/media/addnews-icon.fa17a204.svg";